import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    routeBack: '1',
    token: '',
    count: 0,
    routePath: "/",
    projFilter: {
      isProjAll : 2,
      progress : 0,
      step : 0,
      sorting : 1
    },
    projectFilterSatus : false
  },
  mutations,
})
